import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../login/auth.service';

export const parametersGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.hasParametersPageAccess()) {
        return true;
    }
    return router.createUrlTree(['/home']);
};
